
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/our-story",
      function () {
        return require("private-next-pages/about/our-story.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/our-story"])
      });
    }
  